import { render, staticRenderFns } from "./_base-header.vue?vue&type=template&id=6a99c76a&"
import script from "./_base-header.vue?vue&type=script&lang=js&"
export * from "./_base-header.vue?vue&type=script&lang=js&"
import style0 from "./_base-header.vue?vue&type=style&index=0&id=6a99c76a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports